<script setup lang="ts">
defineProps({
  txt: {
    type: String,
  },
})

// 展开状态
const open = ref(false)
// 展开收起
function handleToggle() {
  open.value = !open.value
}
// 内容元素
const txtCon = ref(null)

const isEll = ref(false)
onMounted(() => {
  const { offsetHeight, scrollHeight } = txtCon.value
  isEll.value = scrollHeight > offsetHeight
})
</script>

<template>
  <div class="txt" :class="open ? 'txt-open' : ''">
    <div ref="txtCon" class="txt-con">
      {{ txt }}
    </div>
    <div v-if="isEll" class="txt-arr" @click="handleToggle">
      <template v-if="!open">
        <i class="iconfont icon-xiangxiajiantou" />
      </template>
      <template v-else>
        <i class="iconfont icon-xiangshangjiantou1" />
      </template>
    </div>
  </div>
</template>

<style scoped lang="scss">
.txt{
  &-arr{
    text-align: center;
    .iconfont{
      font-size: 30px;
    }
  }
  &-con{
    color: #919191;
    line-height: 1.8;
    padding: 10px 20px 0;
    position: relative;
    @include ellnum(2);
  }
  &-open{
    .txt-con{
      overflow: auto;
      -webkit-line-clamp: 9999;
      -webkit-box-orient: vertical;
    }
  }
}
</style>
